// extracted by mini-css-extract-plugin
module.exports = {"weather":"Weather_weather__3R1HE","icon":"Weather_icon__er3y7","divider":"Weather_divider__18U6D","vrijeme":"Weather_vrijeme__3_YfE","podgorica":"Weather_podgorica__2hm8W"};